import Group from 'components/utils/Group'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { EmptyArray, groupBy, min, sortByAll } from 'lib/array/arrayUtils'
import React, { useMemo } from 'react'
import { getAvailablePackagesByRoom, PackagesOptionsViewsByRoom } from 'selectors/offerPage/multipleRoomBookingSelectors'
import Pane from 'components/Common/Pane'
import MobileMultipleRoomsSameRoomOption from './MobileMultipleRoomsSameRoomOption'
import { MultipleRoomPackage, OfferPageFilterType } from 'contexts/OfferPage/offerPageStateReducer'

interface Props {
  rooms: Array<App.RoomOccupants>;
  availablePackagesByRoom: PackagesOptionsViewsByRoom;
  multipleRoomPackages: Array<MultipleRoomPackage>;
  activeFilter?: OfferPageFilterType;
  headerRef: React.RefObject<HTMLDivElement | null>;
}

function MobileMultipleRoomsSameRoomContent(props: Props) {
  const { rooms, availablePackagesByRoom, multipleRoomPackages, activeFilter, headerRef } = props
  const availablePackages = availablePackagesByRoom[rooms[0].roomId]
  const showSelection = activeFilter === 'multiRoomConfirm' || activeFilter === 'multiRoomSelect'
  const optionsByRoomType = useMemo(() => {
    const rawOptions = Array.from(groupBy(availablePackages, (pkg) => pkg?.package.roomType?.id).values())
    return sortByAll(rawOptions, [
      // First order by room that has a package selection (if selection is to be shown)
      { selector: options => showSelection ? (multipleRoomPackages.some(selectedRoom => selectedRoom.roomTypeId === options[0].package.roomType?.id) ? 1 : 0) : 0, direction: 'desc' },
      // Then order by price
      { selector: options => min(options, option => option.hotelTotal), direction: 'asc' },
      // Then order by availability of rooms in the room type from having the most to the least
      { selector: options => (options[0].availableRooms ?? 0) - rooms.length, direction: 'desc' },
    ])
  },
  [availablePackages, multipleRoomPackages, rooms.length, showSelection])

  return (
    <Pane background="neutral-six">
      <Group direction="vertical" gap={8}>
        {optionsByRoomType.map((roomOptions) => <MobileMultipleRoomsSameRoomOption
          key={roomOptions[0].package.roomType?.id}
          packageOptions={roomOptions}
          showSelection={showSelection}
          headerRef={headerRef}
        />)}
      </Group>
    </Pane>
  )
}

type MappedProps = Pick<Props,
  'rooms'
  | 'availablePackagesByRoom'
  | 'multipleRoomPackages'
  | 'activeFilter'
>

export default withOfferPageAndReduxState((state, appState): MappedProps => ({
  rooms: state.rooms ?? EmptyArray as Array<App.RoomOccupants>,
  availablePackagesByRoom: getAvailablePackagesByRoom(state, appState),
  multipleRoomPackages: state.multipleRoomPackages,
  activeFilter: state.activeFilter,
}), MobileMultipleRoomsSameRoomContent)
